export const roles = {
    Spc: "SPC",
    Admin: "Admin",
    Manager: "Manager",
    Recruiter: "Recruiter",
    Candidate: "Candidate",
    SuperAdmin: "SuperAdmin",
    HR: "HR",
    PNM: "Planning and Mobilisation",
}